<template>
  <div class="top-bar" :style="config && 'background-image:url('+config.bgImg +');background-color: ' + config.bgcolor">
    <!-- <img class="topbg" src="~assets/imgs/bg.jpg"></img> -->
    <div @click="goRoute" class="user" :style="config && 'color:'+config.ucenter_color" >
      <!-- <div class="avatar">
        <img class="img" :src="(user.authority && user.authority.auth_avatar) || user.avatar" ></img>
      </div>
      <div class="user-info">
        <span class="name">{{(user.authority && user.authority.auth_nickname) || user.nickname || '游客'}}</span>
        <button v-if="user.id" class="btn">我的发布</button>
        <button v-else class="btn" @click.stop.prevent="cbgcAuth">登录</button>
      </div> -->
      <div class="avatar">
        <div class="topicStyle">
        {{topic}}
        </div>
      </div>
    </div>
    <!-- {{config}} -->
  </div>
</template>
<script>
  let that;
  export default {
    name: 'TopBar',
    props: ['config', 'typeId','topic'],
    computed:{
      user(){
        return this.$store.state.user || {
          avatar: require('assets/imgs/padom.png')
        };
      },
      tokens(){
        return this.$store.state.tokens || '';
      },
      bg(){
        return this.config ? `background-image:url(${this.config.bgImg})` : '';
      }
    },
    methods:{
      cbgcAuth(){
        that = this;
        this.$store.dispatch('cbgcAuth').then(res=>{
          if(res.status){
            this.$emit('showTip', res.message);
            return;
          }
          that.$emit('updateList');
        });
      },
      goRoute(){
        this.user.nickname && this.$router.push({
          name: 'Profile',
          params: {
            id: this.user.id
          },
          query:{
            contentId: this.typeId,
            nickname: this.user.nickname,
            avatar: this.user.avatar,
            is_authority: this.user.is_authority
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  .top-bar{
    position: relative;
    z-index: 10;
    overflow: hidden;
    box-sizing: border-box;
    width: 100vw;
    height: 25.5vw;
    padding: 1.4em 3.33vw .9em;
    /* background: url('~assets/imgs/bg.jpg') center center no-repeat; */
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .topbg{
      position: absolute;
      left: 0;
      top:0;
      z-index: 1;
      width: 100%;
    }
  .user{
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .avatar{
      margin-right: .5em;
      .img{
        width: 13.3vw;
        height: 13.3vw;
        border-radius: 100%;
        border: 1px solid #fff;
        background: #fff;
      }
      .topicStyle{
        margin-top: 1.1em;
        font-size:1.4em;
      }
    }
  }
 
  .user-info{
    display: block;
    color: inherit;
    /* color: #fff; */
    .name, .btn{
      display: block;
      font-size: 1em;
      text-align: left;
    }
    .name{
      line-height: 1;
      margin: 1.2em 0 .2em;
    }
    .btn{
      display: block;
      padding: 0 1em 1em 0;
      color: inherit;
      font-weight: 700;
    }
  }
</style>